﻿import { IOrderTrackingDetails } from '@nkr/models/order-tracking-details';

﻿export interface IOrderRequest {
    //recipient info
    id: number,
    entityType: number,
    entityTypeId: number,
    kitTypeLabel?: string,
    organType: number,
    swapNumber: string,
    swapUrl: string,
    patientUrl: string,
    patientId: number,
    patientAlias: string,
    patientCenterId: number,
    patientCenterAlias: string,
    shippingVendorId: number,
    statusId: number,
    vendorOrderNumber: string,
    inboundTrackingToNkrLab: string,
    internalTrackingNumber: string,
    outboundTrackingNumber: string,
    inboundTrackingNumber: string,
    emailNoticeSent: boolean,
    phlebotRequired: boolean,
    phlebotRequestId: number,
    trackingUrl: string,
    orderDateTime: string,
    deliveredToDonorDateTime: string,
    deliveredToNkrLabDateTime: string,
    collectionDate: string,
    completionDeadline: string,
    surgeryDate: string,

    comments: string,
    lastUpdated: string,

    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorUrl: string,

    resultsAvailable: boolean,
    resultsUrl: string,

    trackingDetails: IOrderTrackingDetails,

    // Multi-ID search criteria (only populated in Partial<IOrderRequest> search payloads)
    entityTypeIds?: number[],
    statusIds?: number[]
}